<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
        <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('home_work.title') + ' ' + $t('globalTrans.entry') }}</h4>
        </template>
        <template v-slot:headerAction>
            <router-link to="/disability-school-service/exam-and-result-management/home-work-evolution" :class="'btn btn-primary text-light'"><i class="ri-file-text-line"></i>{{ $t('home_work.title') + ' ' + $t('globalTrans.list') }}</router-link>
        </template>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(getAssingedCurricular)" @reset.prevent="reset" enctype="multipart/form-data">
                    <b-overlay :show="unitLoad">
                        <b-col lg="12" sm="12">
                            <iq-card>
                                <template v-slot:body>
                                    <b-row>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="organiation_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    :disabled="item ? true : false"
                                                    v-model="assessment.org_id"
                                                    :options="orgList"
                                                    id="organiation_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Institute Type" vid="office_type_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="office_type_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('child_configuration.institute_type')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    :disabled="item ? true : false"
                                                    v-model="assessment.office_type_id"
                                                    :options="officeTypeList"
                                                    id="office_type_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Institute Name" vid="office_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="office_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('child_configuration.institute_name')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    :disabled="item ? true : false"
                                                    v-model="assessment.office_id"
                                                    :options="officeList"
                                                    id="office_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Class" vid="class_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="class_id"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                    <template v-slot:label>
                                                        {{$t('ds_institute_management.class')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                        plain
                                                        :disabled="item ? true : false"
                                                        v-model="assessment.class_id"
                                                        id="class_id"
                                                        :options="classList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <b-spinner v-if="studentSpinLoader" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                            <ValidationProvider name="Student ID" vid="student_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="student_id"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                    <template v-slot:label>
                                                        {{$t('ds_student_management.student_name')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                        plain
                                                        :disabled="item ? true : false"
                                                        v-model="assessment.applicant_id"
                                                        id="student_id"
                                                        :options="studentList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12" md="4">
                                            <ValidationProvider name="Year" vid="year_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="year_id "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('globalTrans.year')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    :disabled="item ? true : false"
                                                    v-model="assessment.year"
                                                    id="year_id"
                                                    :options="yearList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="IEP Slot" vid="slot" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="slot "
                                                    slot-scope="{ valid, errors }"
                                                >
                                                    <template v-slot:label>
                                                        {{$t('ds_student_management.slot')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                        plain
                                                        :disabled="item ? true : false"
                                                        v-model="assessment.slot_id"
                                                        id="slot_id"
                                                        :options="IepSlotList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <hr v-if="assessment.slot_id && assessment.applicant_id">
                                    <b-row v-if="assessment.slot_id && assessment.applicant_id">
                                        <b-col md="12">
                                           <table class="table">
                                               <tr class="text-center bg-gray">
                                                   <th>{{$t('home_work.subject')}}</th>
                                                   <th>{{$t('home_work.status')}}</th>
                                                   <th>{{$t('home_work.remarks')}}</th>
                                               </tr>
                                               <tr v-for="(item, index) in subjects" :key="index">
                                                   <td style="width: 40%">{{ item.text }}</td>
                                                   <td style="width: 30%">
                                                       <ValidationProvider name="Mark Type" :vid="'mark_type' + index" rules="required|min_value:1">
                                                           <b-form-group
                                                               :label-for="'mark_type'+index"
                                                               slot-scope="{ valid, errors }"
                                                               class="row mb-0"
                                                           >
                                                               <b-form-radio-group
                                                                   v-model="item.status"
                                                                   :options="getOption"
                                                                   value-field="value"
                                                                   text-field="text"
                                                                   :state="errors[0] ? false : (valid ? true : null)"
                                                               ></b-form-radio-group>
                                                               <div class="invalid-feedback d-block">
                                                                   {{ errors[0] }}
                                                               </div>
                                                           </b-form-group>
                                                       </ValidationProvider>
                                                   </td>
                                                   <td style="width: 30%">
                                                       <ValidationProvider name="Mark Type" :vid="'mark_type2' + index" rules="required|min_value:1">
                                                           <b-form-group
                                                               :label-for="'mark_type2'+index"
                                                               slot-scope="{ valid, errors }"
                                                               class="row mb-0"
                                                           >
                                                               <b-form-radio-group
                                                                   v-model="item.remarks"
                                                                   :options="getOption2"
                                                                   value-field="value"
                                                                   text-field="text"
                                                                   :state="errors[0] ? false : (valid ? true : null)"
                                                               ></b-form-radio-group>
                                                               <div class="invalid-feedback d-block">
                                                                   {{ errors[0] }}
                                                               </div>
                                                           </b-form-group>
                                                       </ValidationProvider>
                                                   </td>
                                               </tr>
                                           </table>
                                        </b-col>
                                        <b-col class="text-right" md="12">
                                            <b-button type="submit" variant="primary">{{ $t('globalTrans.submit')}}</b-button>
                                        </b-col>
                                    </b-row>
                                </template>
                            </iq-card>
                        </b-col>
                    </b-overlay>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { studentHomeWorkEvalutionStoreApi, studentInfo, studentHomeWorkEvalutionUpdateApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
  props: ['item'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      unitLoad: false,
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      assessment: {
          year: 0,
          org_id: 0,
          office_type_id: 0,
          office_id: 0,
          class_id: 0,
          slot_id: 0,
          applicant_id: 0,
          marks: []
      },
        marksData: [],
      studentSpinLoader: false,
      tmpStudentList: [],
      studentList: [],
      officeTypeList: [],
      officeList: [],
        itemData: null
    }
  },
  created () {
    this.assessment.org_id = this.$store.state.dataFilters.orgId
    this.assessment.office_type_id = this.$store.state.dataFilters.officeTypeId
    this.assessment.office_id = this.$store.state.dataFilters.officeId
    if (this.item) {
        this.assessment.year = this.item.year
        this.assessment.org_id = this.item.org_id
        this.assessment.office_type_id = this.item.office_type_id
        this.assessment.office_id = this.item.office_id
        this.assessment.class_id = this.item.class_id
        this.assessment.slot_id = this.item.iep_slot_id
        this.assessment.applicant_id = this.item.applicant_id
        this.assessment.assessment_date = this.item.assessment_date
       // this.getAssingedCurricular()
    }
  },
  mounted () {
    core.index()
    flatpickr('.date-picker', {})
  },
  computed: {
      subjects: function () {
       const t = [
            { value: 1, text: this.$i18n.locale === 'en' ? 'Student Attendance' : 'ছাত্র উপস্থিতি' },
            { value: 2, text: this.$i18n.locale === 'en' ? "Guardian's collaboration" : 'অভিভাবকের সহায়তা' },
            { value: 3, text: this.$i18n.locale === 'en' ? 'Perform specific household chores' : 'বাড়ির নির্দিষ্ট কাজ সম্পাদন' },
            { value: 4, text: this.$i18n.locale === 'en' ? 'Accept and follow the information / instructions written in the diary' : 'ডায়েরিতে লেখা তথ্য/নির্দেশনা গ্রহণ ও পালন' },
            { value: 5, text: this.$i18n.locale === 'en' ? 'Personal hygiene of students' : 'ছাত্রদের ব্যক্তিগত পরিস্কার পরিচ্ছন্নতা' }
        ]
            if (this.item) {
                this.item.details.forEach(function (element, index) {
                    t[index].status = element.is_regular
                    t[index].remarks = element.is_satisfied
                })
            }
          return t
      },
      getOption: function () {
        return [
            { value: 1, text: this.$i18n.locale === 'en' ? 'Regular' : 'নিয়মিত' },
            { value: 2, text: this.$i18n.locale === 'en' ? 'Irregular' : 'অনিয়মিত' }
        ]
    },
      getOption2: function () {
        return [
            { value: 1, text: this.$i18n.locale === 'en' ? 'Satisfactory' : 'সন্তোষজনক' },
            { value: 2, text: this.$i18n.locale === 'en' ? 'Dissatisfactory' : 'অসন্তোষজনক' }
        ]
    },
      classList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.classList.filter(item => item.status === 1)
    },
    IepSlotList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.IepSlotList.filter(item => item.status === 1)
    },
    yearList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.yearList.map(item => {
            if (this.$i18n.locale === 'bn') {
                return { value: item, text: this.$n(item, { useGrouping: false }) }
            } else {
                return item
            }
        })
    },
    getAffirmativeList: function () {
        return this.affirmativeList.map(item => {
            return Object.assign({}, item, { value: item.value, text: this.$i18n.locale === 'en' ? item.text_en : item.text_bn })
        })
    },
    orgList: function () {
        return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    currentLocale () {
        return this.$i18n.locale
    }
  },
  watch: {
    'assessment.org_id': function (newVal, oldVal) {
        this.getOfficeTypeList()
        if (this.assessment.office_id && this.assessment.office_type_id && this.assessment.class_id && !this.item.id) {
            this.getStudentData()
        }
    },
    'assessment.office_type_id': function (newVal, oldVal) {
        this.getOfficeList()
        if (this.assessment.org_id && this.assessment.office_id && this.assessment.class_id && !this.item.id) {
            this.getStudentData()
        }
    },
    'assessment.office_id': function (newVal, oldVal) {
        if (this.assessment.org_id && this.assessment.office_type_id && this.assessment.class_id && !this.item.id) {
            this.getStudentData()
        }
    },
    'assessment.class_id': function (newVal, oldVal) {
        this.getStudentData()
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.assessment.org_id) {
                this.getOfficeTypeList()
            }
            if (this.assessment.office_type_id) {
                this.getOfficeList()
            }
            this.getStudentList()
        }
    }
  },
  methods: {
    getAssingedCurricular () {
        if (this.item) {
            this.unitLoad = true
            this.assessment.marks = this.subjects
            this.assessment.id = this.item.id
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            RestApi.postData(disabilitySchoolServiceBaseUrl, studentHomeWorkEvalutionUpdateApi, this.assessment).then(response => {
                if (response.success) {
                    this.unitLoad = false
                    this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
                    this.$toast.success({
                        title: this.$t('globalTrans.success'),
                        message: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
                        color: '#D6E09B'
                    })

                    this.$router.push({ path: '/disability-school-service/exam-and-result-management/home-work-evolution' })
                } else {
                    this.unitLoad = false
                    this.$refs.form.setErrors(response.errors)
                }
            })
        } else {
            this.unitLoad = true
            this.assessment.marks = this.subjects
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            RestApi.postData(disabilitySchoolServiceBaseUrl, studentHomeWorkEvalutionStoreApi, this.assessment).then(response => {
                if (response.success) {
                    this.unitLoad = false
                    if (response.notification && this.$store.state.emitNotification) {
                        const notification = response.notification
                        this.$socket.emit('send-notification', notification)
                    }
                    this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
                    this.$toast.success({
                        title: this.$t('globalTrans.success'),
                        message: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
                        color: '#D6E09B'
                    })

                    this.$router.push({ path: '/disability-school-service/exam-and-result-management/home-work-evolution' })
                } else {
                    this.unitLoad = false
                    this.$toast.error({
                        title: this.$t('globalTrans.error'),
                        message: response.message,
                        color: '#D6E09B'
                    })
                    this.$refs.form.setErrors(response.message)
                }
            })
        }
    },
    getRelationalData (Obj) {
        const listData = Object.keys(Obj).map(key => {
            const tmpType = this.$store.state.DisabilitySchoolService.commonObj.curricularTypeList.find(el => el.value === parseInt(key))
            const newData = {
                type_name: tmpType !== undefined ? tmpType.text_en : '',
                type_name_bn: tmpType !== undefined ? tmpType.text_bn : '',
                curricular_type_id: key
            }
            this.assessment.edu_plan_id = Obj[key][0].edu_main_id
            const arryList = Obj[key].map(item => {
                const activityData = Object.assign({
                    curricular_activity_id: item.curricular_activity_id,
                    activity_name: item.curricular_activity.activity_name,
                    activity_name_bn: item.curricular_activity.activity_name_bn,
                    // edu_main_id: item.edu_main_id,
                    id: item.id,
                    checked: 0
                })
                return activityData
            })
            newData.activities = arryList
            return newData
        })
        return listData
    },
    async getStudentData () {
        this.studentSpinLoader = true
        let result = null
        result = await RestApi.postData(disabilitySchoolServiceBaseUrl, studentInfo, { office_id: this.assessment.office_id, class_id: this.assessment.class_id })
        if (result.success) {
            this.studentSpinLoader = false
            this.tmpStudentList = result.data
            this.getStudentList()
        }
    },
    getCurricularTypeName (Id) {
        const Obj = this.$store.state.DisabilitySchoolService.commonObj.curricularTypeList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return Obj.text_bn
        } else {
            return Obj.text_en
        }
    },
    getStudentList () {
        this.studentList = this.tmpStudentList.map(item => {
            if (this.$i18n.locale === 'en') {
                return Object.assign({ value: item.value, text: item.text_en + ' (Roll-' + item.student_id + ')' })
            } else {
                return Object.assign({ value: item.value, text: item.text_bn + ' (রোল-' + this.$n(item.student_id, { useGrouping: false }) + ')' })
            }
        })
    },
    getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.assessment.org_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.assessment.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    }
  }
}
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
